import React from "react";
import { Menu as MenuIcon } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import CreditsChip from "@/components/CreditsChip";

const TITLES = {
  chat: "Chat with Rammy",
  home: "Today",
  memories: "Rings",
  reminders: "Reminders",
  settings: "Settings",
  integrations: "Connections",
  inbox: "Inbox",
  emails: "Focus inbox",
  focus: "Focus",
  calendar: "Calendar",
  studio: "Studio",
  creations: "Creations",
  credits: "Credits",
  rituals: "Rituals",
  "sent-replies": "Sent replies",
  plans: "Plans",
  privacy: "Privacy",
  family: "Family",
  find: "Find my Rammy",
  ota: "Firmware · OTA",
  pair: "Pair a Rammy",
  personality: "Personality",
  voice: "Voice",
  language: "Language",
};

const BACK_SCREENS = new Set([
  "personality", "voice", "language", "privacy", "plans",
  "family", "find", "ota", "pair", "sent-replies",
]);

/**
 * MainHeader — top bar for the AppShell. Renders:
 *   • Mobile hamburger (opens the sidebar drawer)
 *   • Contextual "Back to settings" link on nested settings routes
 *   • Screen title + user plan + email on desktop
 */
export default function MainHeader({ screen, user, setScreen, onOpenMobileNav }) {
  const back = BACK_SCREENS.has(screen);
  return (
    <header
      className="h-14 border-b border-[var(--rammy-border)] bg-[var(--rm-surface)]/85 backdrop-blur-xl flex items-center justify-between px-4 md:px-6 shrink-0"
      data-testid="app-header"
    >
      <div className="flex items-center gap-3 min-w-0">
        <button
          type="button"
          onClick={onOpenMobileNav}
          className="md:hidden w-9 h-9 rounded-xl border border-[var(--rammy-border)] flex items-center justify-center text-[var(--rammy-text)] hover:bg-[var(--rammy-surface-alt)]"
          aria-label="Open menu"
          data-testid="app-header-menu"
        >
          <MenuIcon size={18}/>
        </button>
        {back && (
          <button
            onClick={() => setScreen("settings")}
            className="text-xs uppercase tracking-widest text-[var(--rammy-cyan-dark)] font-semibold"
            data-testid="header-back"
          >
            ← Back to settings
          </button>
        )}
        <div className="font-display text-lg truncate" data-testid="header-title">
          {TITLES[screen] || "Rammy"}
        </div>
      </div>
      <div className="flex items-center gap-3 text-xs text-[var(--rammy-text-muted)]">
        <CreditsChip />
        <ThemeToggle testId="app-theme-toggle" />
        <span className="hidden md:inline">{user?.plan?.toUpperCase() || "FREE"} plan</span>
        <span className="hidden md:inline">·</span>
        <span className="hidden md:inline truncate max-w-[220px]">{user?.email}</span>
      </div>
    </header>
  );
}
